import { Link } from 'react-router-dom';
import { FilePlus, Images, ChevronRight } from 'lucide-react';

// The "Add products" fork: one at a time with the full editor, or bulk — drop a
// pile of photos, group them into items, and fill them out fast.
export default function AdminAddChoicePage() {
  const options = [
    {
      to: '/admin/products/new',
      icon: FilePlus,
      title: 'Upload items',
      blurb: 'Add one product at a time with the full editor — name, price, photos, condition, and the rest.',
    },
    {
      to: '/admin/products/bulk',
      icon: Images,
      title: 'Bulk upload',
      blurb: 'Drop a pile of photos, tap to group them into items, and process the whole batch at once.',
    },
  ];

  return (
    <div style={{ maxWidth: 640 }}>
      <Link to="/admin/products" style={{ fontSize: '0.85rem', color: 'var(--text-muted)', display: 'inline-block', marginBottom: 16 }}>
        ← Back to products
      </Link>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: 6 }}>Add products</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', marginBottom: 24 }}>
        Pick how you want to add inventory.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {options.map(({ to, icon: Icon, title, blurb }) => (
          <Link
            key={to}
            to={to}
            className="sv-card"
            style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 20, textDecoration: 'none' }}
          >
            <div style={{
              flexShrink: 0, width: 52, height: 52, borderRadius: 14, display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              background: 'color-mix(in srgb, var(--accent) 14%, transparent)', color: 'var(--accent)',
            }}>
              <Icon size={26} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: '1.05rem', color: 'var(--text)' }}>{title}</div>
              <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginTop: 3, lineHeight: 1.4 }}>{blurb}</div>
            </div>
            <ChevronRight size={20} style={{ flexShrink: 0, color: 'var(--text-muted)' }} />
          </Link>
        ))}
      </div>
    </div>
  );
}
